import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef, useMemo } from "react";
import { useI18n } from "../../../../i18n/i18n";
import { VisuallyHidden } from "../../../visuallyhidden";
import { MultiSelectOption } from "./MultiSelectOption";
export const SelectAllOption = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    checkedState,
    totalSelectedItems,
    totalOptions,
    ...rest
  } = _ref;
  const {
    i18n
  } = useI18n();
  const allOrSomeSelected = totalSelectedItems === totalOptions || totalSelectedItems > 0;
  const ariaLabel = useMemo(() => {
    switch (allOrSomeSelected) {
      case true:
        return i18n._( /*i18n*/{
          comment: "This aria label is read to the user conveying the number of items selected. Then full stop. Then it conveys that clicking on the option will deselect all the items",
          id: `{totalSelectedItems} selected. Deselect all`,
          values: {
            totalSelectedItems
          }
        });
      case false:
        return i18n._( /*i18n*/{
          comment: "This aria label conveys that clicking on the option will select all the items",
          id: `{totalSelectedItems} selected. Select all {totalOptions} items`,
          values: {
            totalSelectedItems,
            totalOptions
          }
        });
    }
  }, [allOrSomeSelected, totalOptions, totalSelectedItems, i18n]);
  return /*#__PURE__*/React.createElement(MultiSelectOption, _extends({
    checkedState: checkedState,
    ref: ref,
    onClick: e => {
      rest.onClick?.(e);
    },
    "aria-label": ariaLabel
  }, rest), totalSelectedItems === 0 ? i18n._( /*i18n*/"Select All") : i18n._( /*i18n*/{
    comment: "This is to show the number of selected items",
    id: `{totalSelectedItems} selected`,
    values: {
      totalSelectedItems
    }
  }), /*#__PURE__*/React.createElement(VisuallyHidden, null, i18n._( /*i18n*/"Press Enter to select or deselect an option.")));
});
SelectAllOption.displayName = "SelectAllOption";
//# sourceMappingURL=SelectAllOption.js.map